import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Button } from 'primeng/button';
import { Dialog, DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputText, InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { Select } from 'primeng/select';
import { Subject } from 'rxjs';
import { SimpleChanges } from '@angular/core';
import {
  debounceTime,
  distinctUntilChanged,
  takeUntil,
  filter,
} from 'rxjs/operators';

@Component({
  selector: 'app-plano-curricular-disciplina-cadastrar-editar',
  imports: [
    Button,
    MessageModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
    Select,
    DialogModule,
    Dialog,
    CommonModule,
    InputText,
    InputTextModule,
    CheckboxModule,
  ],
  templateUrl: './plano-curricular-disciplina-cadastrar-editar.component.html',
  styleUrls: ['./plano-curricular-disciplina-cadastrar-editar.component.scss'],
})
export class PlanoCurricularDisciplinaCadastrarEditarComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() planoCurricularID: number | null = null;
  @Output() saveDisciplinaEvent = new EventEmitter<any>();
  @Output() close = new EventEmitter<void>();
  @Output() changeTipoPedido = new EventEmitter<any>();
  @Input() isLoading: boolean = false;
  @Input() disciplina: any | null = null;
  @Input() disciplinaOptions: any[] = [];
  @Input() periodoList: any[] = [];
  @Input() tipoPedidoList: any[] = [];
  @Input() visibleDisciplinaForm = false;
  @Input() anoCurricular: number | null = null;
  private isPatching = false;
  disciplinaForm!: FormGroup;
  private destroy$ = new Subject<void>();
  semestre = [
    { name: 'Semestral', value: 1 },
    { name: 'Anual', value: 2 },
  ];

  constructor(private fb: FormBuilder) {
    this.disciplinaForm = this.fb.group({
      isNewDisciplina: [false], // Adicionado ao FormGroup
      id: [null],
      disciplinaID: [0],
      disciplinaDesignacao: [''],
      periodoID: [null, Validators.required],
      tipoPeriodoID: [null],
      cargaHoraria: [null, [Validators.required, Validators.min(1)]],
      planoCurricularID: [this.planoCurricularID],
      anoCurricular: [this.anoCurricular, Validators.required],
      regime: [1, Validators.required],
    });

    this.disciplinaForm.controls['tipoPeriodoID'].valueChanges
      .pipe(
        // filter(() => !this.isPatching), // só emite se não estiver patchando
        debounceTime(250), // evita múltiplas emissões rápidas
        distinctUntilChanged(), // só emite se o valor realmente mudou
        // takeUntil(this.destroy$)
      )
      .subscribe((value) => {
        // if (this.isLoading) return;
        this.changeTipoPedido.emit(value);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Só faz patch se disciplina mudar (ou se for a primeira vez)
    if (changes['disciplina'] && this.disciplina) {
      // Pode comparar ID, ou outro campo que faça sentido para evitar patchValue desnecessário
      const newID = this.disciplina?.disciplinaID;
      const currentID = this.disciplinaForm.get('disciplinaID')?.value;
      if (newID !== currentID) {
        this.isPatching = true;
        this.disciplinaForm.patchValue({
          ...this.disciplina,
          disciplinaID: this.disciplina?.disciplinaID,
          disciplinaDesignacao: this.disciplina?.disciplinaDesignacao,
          planoCurricularID: this.planoCurricularID,
          cargaHoraria: this.disciplina?.cargaHoraria,
          anoCurricular: this.anoCurricular,
          tipoPeriodoID: this.disciplina?.tipoPeriodoID,
          periodoID: this.disciplina?.periodoID,
          regime: this.disciplina?.regimeID,
          isNewDisciplina: false,
        });
        ['isNewDisciplina', 'disciplinaID'].forEach((control) => {
          if (this.disciplinaForm.controls[control]) {
            this.disciplinaForm.controls[control].disable();
          }
        });
        setTimeout(() => (this.isPatching = false));
      }
    }
  }

  ngOnInit(): void {}

  saveDisciplina(): void {
    this.disciplinaForm.markAllAsTouched();
    const rawValue = this.disciplinaForm.getRawValue();
    const formData = {
      ...rawValue,
      planoCurricularID: this.planoCurricularID,
      anoCurricular: this.anoCurricular,
      disciplinaID: rawValue.isNewDisciplina ? null : rawValue.disciplinaID,
    };
    this.saveDisciplinaEvent.emit(formData);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
